import {useState} from 'react'
import './App.scss';
import Header from './Components/Header'

import Home from './Components/Home'
import Market from './Components/Market'
import EventGallery from './Components/EventGallery'
import Event from './Components/Event'

import Modal from './Components/Modal'

import Footer from './Components/Footer'
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';

function App() {

  let [darkMode, setDarkMode] = useState(localStorage.getItem("mode") === "true")
  let [modalWindow, setModalWindow] = useState(false)

  return (
    <div className="App" style={{ height: modalWindow? "100vh" : "", overflow: modalWindow? "hidden" : "" }}>
      <Router>
        <Header darkMode={darkMode} setDarkMode={setDarkMode} setModalWindow={setModalWindow} modalWindow={modalWindow} />
        <div className="content">
          <Route exact path="/" component={() => (<Redirect to='/media_eye' />)} />
          <Route path="/media_eye" render={() => (
            <Home darkMode={darkMode}/>
          )}/>
           <Route path="/market" render={() => (
            <Market darkMode={darkMode}/>
          )}/>  
           <Route path="/gallery" render={() => (
            <EventGallery darkMode={darkMode}/>
          )}/>                
           <Route path="/event:id" render={() => (
            <Event darkMode={darkMode}/>
          )}/>                         
        </div>
        <Modal darkMode={darkMode} setModalWindow={setModalWindow} modalWindow={modalWindow}/>
        <Footer darkMode={darkMode} />
      </Router>
    </div>
  );
}

export default App;
